import { Flipside as FlipsideSDK } from '@flipsidecrypto/sdk';

const flipside = new FlipsideSDK(
    "6583fbba-51cd-4209-be6d-4d6abe5972ab",
    "https://node-api.flipsidecrypto.com"
);

export function sleep(ms: number) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(true);
        }, ms);
    });
}

export const queryTillSuccess = async(statement: string, tries: number = 3) => {
    let currentTries = 0;

    while(true) {
        try {
            return await query(statement);
        }

        catch (e){
            console.log(e);
            currentTries++;
            if(currentTries > tries) {
                throw Error("Exceeded number of tries");
            }
            await sleep(3000);
            continue;
        }
    }
}

export const query = async(statement: string) => {
    let query = {
        sql: statement,
        ttlMinutes: 10,
    };
    let ret = await flipside.query.run(query);

    //ignore USER_ERROR
    if(ret.error && ret.error.errorType !== 'USER_ERROR') {
        throw Error("");
    }

    if(!ret.records) {
        return [];
    }

    return ret.records;
}

/**
 * Returns the number with 'en' locale settings, ie 1,000
 * @param x number
 * @param minDecimal number
 * @param maxDecimal number
 */
 export function toLocaleDecimal(x: number, minDecimal: number, maxDecimal: number) {
    return x.toLocaleString('en', {
        minimumFractionDigits: minDecimal,
        maximumFractionDigits: maxDecimal,
    });
}

/**
 * Runs the function if it's a function, returns the result or undefined
 * @param fn
 * @param args
 */
export const runIfFunction = (fn: any, ...args: any): any | undefined => {
    if(typeof(fn) == 'function'){
        return fn(...args);
    }

    return undefined;
}

/**
 * Returns the ellipsized version of string
 * @param x string
 * @param leftCharLength number
 * @param rightCharLength number
 */
export function ellipsizeThis(x: string, leftCharLength: number, rightCharLength: number) {
    if(!x) {
        return x;
    }

    let totalLength = leftCharLength + rightCharLength;

    if(totalLength >= x.length) {
        return x;
    }

    return x.substring(0, leftCharLength) + "..." + x.substring(x.length - rightCharLength, x.length);
}

/**
 * Returns the new object that has no reference to the old object to avoid mutations.
 * @param obj
 */
export const cloneObj = <T = any>(obj: {[key: string]: any}) => {
    return JSON.parse(JSON.stringify(obj)) as T;
}